import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withModifiers as _withModifiers, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "container max-w-2xl mx-auto flex flex-col items-center justify-center min-h-full px-4 md:px-0" }
const _hoisted_2 = { class: "container max-w-2xl mx-auto flex flex-col items-center justify-center min-h-full px-6 md:px-0" }
const _hoisted_3 = ["src"]
const _hoisted_4 = /*#__PURE__*/_createElementVNode("h1", { class: "text-xl font-semibold text-black mb-2" }, "Link is no longer valid", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("p", { class: "text-center text-base font-medium" }, " This log in link has expired. Tap the button below to request a new log in link. ", -1)
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" Request a new log in link ")
const _hoisted_7 = { class: "bg-gray-100" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_IonButton = _resolveComponent("IonButton")!
  const _component_BaseCard = _resolveComponent("BaseCard")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ion_icon = _resolveComponent("ion-icon")!
  const _component_ion_footer = _resolveComponent("ion-footer")!
  const _component_ion_loading = _resolveComponent("ion-loading")!
  const _component_ion_page = _resolveComponent("ion-page")!

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withCtx(() => [
      _createVNode(_component_ion_content, { fullscreen: "" }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createVNode(_component_BaseCard, { class: "flex flex-col items-center h-auto p-8" }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_2, [
                  _createElementVNode("img", {
                    id: "bellicon",
                    class: "mb-6 mt-4 w-12 h-12",
                    src: $setup.bellIcon,
                    alt: "",
                    role: "presentation"
                  }, null, 8, _hoisted_3),
                  _hoisted_4,
                  _hoisted_5
                ]),
                _createVNode(_component_IonButton, {
                  color: "primary",
                  expand: "block",
                  fill: "solid",
                  class: "w-full mt-8",
                  onClick: _withModifiers($setup.sendMagicLink, ["prevent"])
                }, {
                  default: _withCtx(() => [
                    _hoisted_6
                  ]),
                  _: 1
                }, 8, ["onClick"])
              ]),
              _: 1
            })
          ])
        ]),
        _: 1
      }),
      _createVNode(_component_ion_footer, null, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_7, [
            _createVNode(_component_ion_icon, {
              id: "bp-logo",
              src: $setup.bigPicture,
              class: "w-full h-20"
            }, null, 8, ["src"])
          ])
        ]),
        _: 1
      }),
      _createVNode(_component_ion_loading, {
        "is-open": $setup.isLoading,
        message: "Sending email"
      }, null, 8, ["is-open"])
    ]),
    _: 1
  }))
}